<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>
  <!-- header -->
  <header>
    <div class="headline">
      <h1>
        {{ 'Work_Order_Details_Title' | translateWF: 'Work Order' }}:
        {{ workOrder && !isCopyMode ? workOrder.orderNumber : ('Work_Order_Details_Title_New' | translateWF: 'New') }}
      </h1>
      <csl-dropdown [formControl]="status" [enumObject]="statusEnumObject" [enumValueOptions]="workOrderStatusOptions"></csl-dropdown>
    </div>
    <div class="buttons">
      <p-button severity="secondary" icon="pi pi-print" *ngIf="workOrder?.id" (click)="printWorkOrderReport()"></p-button>
      <button pButton class="cs-button-link" label="Manual" (click)="goToInternalLink()">
        <i class="pi pi-arrow-right"></i>
      </button>
      <p-button *ngIf="getShowSaveButton() || isShortFall" [label]="'Save' | translateWF: 'Save'" [disabled]="!canEdit()" (click)="save()" />
      <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancel()" />
    </div>
  </header>

  <!-- main content -->
  <div class="content">
    <div class="grid-12">
      <!-- Fabrics Summary -->
      <div class="col span-12-8-8">
        <p-panel [header]="'Work_Order_Details_Fabrics_Summary' | translateWF: 'Fabrics Summary'">
          <p-card>
            <div class="grid-12 gap-[1rem]">
              <div class="span-3 content-end">
                <div class="form-box">
                  <label>{{ 'Work_Order_Details_Total_Fabric_Quantity' | translateWF: 'Total Fabric Quantity' }}</label>
                  <p-inputGroup>
                    <p-inputnumber fluid class="w-full" [ngModel]="fabricYardsQuantity" mode="decimal" [disabled]="true" [minFractionDigits]="2" [maxFractionDigits]="5" />
                    <p-inputGroupAddon> yd </p-inputGroupAddon>
                  </p-inputGroup>
                </div>
              </div>
              <div class="span-3 content-end">
                <div class="form-box">
                  <label>{{ 'Work_Order_Details_Total_Fabric_Quantity' | translateWF: 'Total Fabric Quantity' }}</label>
                  <p-inputGroup>
                    <p-inputnumber fluid class="w-full" [disabled]="true" [ngModel]="fabricPoundsQuantity" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5" />
                    <p-inputGroupAddon> lb </p-inputGroupAddon>
                  </p-inputGroup>
                </div>
              </div>
              <div class="span-3 content-end">
                <div class="form-box">
                  <label>
                    {{ 'Work_Order_Details_Total_Yarn_Quantity' | translateWF: 'Total Yarn Quantity' }}
                  </label>
                  <p-inputGroup>
                    <p-inputnumber fluid class="w-full" [formControl]="totalYarnQuantity" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" />
                    <p-inputGroupAddon> lb </p-inputGroupAddon></p-inputGroup
                  >
                </div>
              </div>
              <div class="span-3 content-end">
                <div class="form-box">
                  @if (isShortFall) {
                    @if (workOrder?.parentBulkWorkOrder) {
                      <label>{{ 'Work_Order_Details_Parent_Bulk_WO' | translateWF: 'Parent Work Order' }} {{ workOrder?.parentBulkWorkOrder }}</label>
                    } @else {
                      <label>
                        {{ 'Work_Order_Details_Parent_Bulk_WO' | translateWF: 'Parent Work Order' }}
                        {{ workOrder?.orderNumber }}
                      </label>
                    }
                  } @else {
                    <label
                      [ngClass]="{
                        hidden: workOrder?.orderType! < 3 || orderType === WorkOrderType.GreigeOnly,
                      }"
                    >
                      {{ 'Work_Order_Details_Use_Greiges_From_Order' | translateWF: 'Use Greiges from Order' }}
                    </label>
                  }

                  @if (orderType === WorkOrderType.Linked) {
                    <p-autocomplete
                      appendTo="body"
                      fluid
                      field="orderNumber"
                      [suggestions]="greigeWorkOrderSuggestions"
                      [formControl]="specificWorkOrderGreige"
                      [dropdown]="true"
                      dropdownIcon="pi pi-search"
                      class="w-full"
                      (completeMethod)="greigeWorkOrderTypeAhead($event)"
                      (onSelect)="onSelectGreigeWorkOrderToUse($event)"
                    />
                  }
                </div>
              </div>
              <div class="span-12 content-end">
                @if (this.getShowSaveButton() && canEdit() && !isShortFall) {
                  <div class="form-box">
                    <label>
                      {{ 'Work_Order_Details_Add_Fabric' | translateWF: 'Add Fabric' }}
                    </label>
                    <p-autocomplete
                      appendTo="body"
                      fluid
                      #fabricAutoCompleteInput
                      [dropdown]="true"
                      dropdownIcon="pi pi-search"
                      class="w-full"
                      [suggestions]="filteredFabrics"
                      field="fieldToDisplay"
                      (completeMethod)="fabricsTypeAhead($event)"
                      (onSelect)="onSelectFabric($event); clearAutocomplete(fabricAutoCompleteInput)"
                    />
                    @if (orderType === WorkOrderType.Sample) {
                      <small class="text-muted-color">
                        {{
                          'Work_Order_Details_Fabric_Status_Sample'
                            | translateWF
                              : 'Showing fabrics with status: In
                    Development, Under Review, Approved, Ready for Production'
                        }}
                      </small>
                    } @else {
                      <small class="text-muted-color">
                        {{
                          'Work_Order_Details_Fabric_Status_Default'
                            | translateWF
                              : 'Showing only fabrics with status: Ready
                    for Production'
                        }}
                      </small>
                    }
                  </div>
                }
              </div>
            </div>
          </p-card>
        </p-panel>

        <p-panel header="Notes">
          <csl-standard-notes *ngIf="userLite" [notes]="notes" [userLite]="userLite" [viewOnly]="!canEdit()" (viewMore)="onViewMore()"> </csl-standard-notes>
        </p-panel>

        @if (workOrderFabricFormArrays.controls.length > 0) {
          @for (workOrderFabricForm of workOrderFabricFormArrays.controls; track $index) {
            <app-fabric-details-panel
              [isShortFall]="isShortFall"
              [customer]="orderDetailsForm.value.customer"
              [uom]="unitOfMeasurementEnums[orderDetailsForm.value.uom]"
              [orderType]="orderType"
              [orderDetailsFormSubmitted]="orderDetailsFormSubmitted"
              [customerColors]="customerColors"
              [workOrderFabricForm]="workOrderFabricForm"
              [clientProductOrders]="customerProductOrders"
              [canEdit]="canEdit()"
              [canEditPackingType]="canEditPackingTypeOnly()"
              [allCompositions]="allCompositions"
              [certifications]="certifications"
              (removeFabric)="removeFabricAtList($event)"
              (savePackingType)="onSavePackingType($event)"
            />
          }
        } @else {
          <p-message severity="secondary">{{
            'Work_Order_Details_No_Fabrics_Assigned'
              | translateWF
                : 'There are no fabrics
          assigned to this work order.'
          }}</p-message>
        }
      </div>

      <!-- Work Order Details -->
      <div class="wo-detail-container span-12-4-4">
        <p-tabs class="white__tabs cs-tabs-surface-card cs-tabs-scroll-fill" value="0">
          <p-tablist>
            <p-tab value="0">{{ 'Work_Order_Details_Tab_Order' | translateWF: 'Order' }}</p-tab>
            <p-tab value="1">{{ 'Work_Order_Details_Tab_Client_Product_Orders' | translateWF: 'Client Product Orders' }}</p-tab>
            <p-tab value="2">{{ 'Work_Order_Details_Tab_Info' | translateWF: 'Info' }}</p-tab>
          </p-tablist>
          <p-tabpanels>
            <!-- Tab Order -->
            <p-tabpanel value="0">
              <p-card data-variant="flat">
                <form class="col" [formGroup]="orderDetailsForm">
                  <!-- Order Type -->
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Order_Type' | translateWF: 'Order Type' }}</label>
                    <p-select
                      appendTo="body"
                      formControlName="orderType"
                      [options]="setOptionsForPrimeNg(orderTypesEnums)"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && orderDetailsForm.controls['orderType'].invalid }"
                    />
                  </div>
                  <!-- Order Term -->
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Order_Term' | translateWF: 'Order Term' }}</label>
                    <p-select
                      appendTo="body"
                      formControlName="workOrderTerm"
                      [options]="setOptionsForPrimeNg(workOrderTermEnums)"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && orderDetailsForm.controls['workOrderTerm'].invalid }"
                    />
                  </div>
                  <!-- Order Date -->
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Order_Date' | translateWF: 'Order Date' }}</label>
                    <p-datepicker
                      fluid
                      formControlName="orderReceivedDate"
                      [iconDisplay]="'input'"
                      [showIcon]="true"
                      class="w-full"
                      [ngClass]="{
                        'ng-invalid ng-dirty': orderDetailsFormSubmitted && orderDetailsForm.controls['orderReceivedDate'].invalid,
                      }"
                    />
                  </div>
                  <!-- Unit of Measurement -->
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Unit_Of_Measurement' | translateWF: 'Unit of Measurement' }}</label>
                    <p-select
                      appendTo="body"
                      formControlName="uom"
                      [options]="setOptionsForPrimeNg(unitOfMeasurementEnums)"
                      (onChange)="setUomLabel($event.value)"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && orderDetailsForm.controls['uom'].invalid }"
                    />
                  </div>
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Client' | translateWF: 'Client' }}</label>
                    <p-autocomplete
                      appendTo="body"
                      fluid
                      id="customer"
                      formControlName="customer"
                      [suggestions]="filteredCustomers"
                      optionLabel="name"
                      (completeMethod)="customerTypeAhead($event)"
                      (onSelect)="selectCustomer($event)"
                      [dropdown]="true"
                      dropdownIcon="pi pi-search"
                      class="w-full"
                      [ngClass]="{
                        'ng-invalid ng-dirty': orderDetailsFormSubmitted && orderDetailsForm.controls['customerReference'].invalid,
                      }"
                    >
                      <ng-template let-customer pTemplate="item">
                        <div class="panel__option" [title]="customer.name">
                          {{ customer.name }}
                        </div>
                      </ng-template>
                    </p-autocomplete>
                    <small id="customer" *ngIf="orderDetailsForm.value?.customer?.code">{{ orderDetailsForm.value.customer.code }}</small>
                  </div>
                  <!-- Brand -->
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Brand' | translateWF: 'Brand' }}</label>
                    <p-autocomplete
                      appendTo="body"
                      fluid
                      formControlName="brand"
                      [suggestions]="filteredBrands"
                      optionLabel="name"
                      (completeMethod)="brandTypeAhead($event)"
                      (onSelect)="selectBrand($event)"
                      [dropdown]="true"
                      dropdownIcon="pi pi-search"
                      class="w-full"
                      [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && orderDetailsForm.controls['brandReference'].invalid }"
                    >
                      <ng-template let-brand pTemplate="item">
                        <div class="panel__option" [title]="brand.name">
                          {{ brand.name }}
                        </div>
                      </ng-template>
                    </p-autocomplete>

                    <small id="brand" *ngIf="orderDetailsForm.value?.brand?.code">{{ orderDetailsForm.value.brand.code }}</small>
                  </div>
                  <!-- Negotiated Lead Time -->
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Negotiated_Lead_Time' | translateWF: 'Negotiated Lead Time' }}</label>
                    <p-inputgroup>
                      <p-inputnumber formControlName="negotiatiedLeadTimeInWeeks" />
                      <p-inputGroupAddon> {{ 'Work_Order_Details_Weeks' | translateWF: 'Week(s)' }} </p-inputGroupAddon>
                    </p-inputgroup>
                  </div>

                  <div class="form-box">
                    <label for="">Yarn Origin</label>
                    <p-select
                      fluid
                      formControlName="yarnOrigin"
                      [options]="yarnOriginOptions"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && orderDetailsForm.controls['yarnOrigin'].invalid }"
                    />
                  </div>

                  <h4>{{ 'Work_Order_Details_Planning' | translateWF: 'Planning' }}</h4>
                  <!-- Planning Estimated Date -->
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Planning_Estimated_Date' | translateWF: 'Planning Estimated Date' }}</label>
                    <p-datepicker
                      fluid
                      #planningEstimatedInput
                      formControlName="planningEstimatedYW"
                      [startWeekFromFirstDayOfYear]="true"
                      [showWeek]="true"
                      [iconDisplay]="'input'"
                      [showIcon]="true"
                      (onSelect)="setEstimatedDates('planningEstimated')"
                      [dateFormat]="'yy/' + planningEstimatedWeekNumber"
                      class="w-full"
                    />
                  </div>
                  <!-- Estimated Shipment Date -->
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Estimated_Shipment_Date' | translateWF: 'Estimated Shipment Date' }}</label>
                    <p-datepicker
                      fluid
                      #estimatedShipmentInput
                      formControlName="estimatedShipmentDate"
                      [startWeekFromFirstDayOfYear]="true"
                      [showWeek]="true"
                      [iconDisplay]="'input'"
                      [showIcon]="true"
                      class="w-full"
                    />
                  </div>
                  <h4>{{ 'Work_Order_Details_Billing' | translateWF: 'Billing' }}</h4>
                  <div class="form-box-row row-start-center">
                    <p-checkbox inputId="billingSameAsClient" [binary]="true" [formControl]="billingSameAsClient" (onChange)="onBillingSameAsClientToggle()"></p-checkbox>
                    <label for="billingSameAsClient" class="ml-2">Same as Client</label>
                  </div>

                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Ship_To' | translateWF: 'Bill To' }}</label>
                    @if (billingSameAsClient.value) {
                      <input class="p-inputtext" type="text" [value]="orderDetailsForm.value.customer?.name" disabled />
                    } @else {
                      <p-autocomplete
                        fluid
                        id="billingTo"
                        formControlName="billingTo"
                        [suggestions]="billingToOptions"
                        field="fieldToDisplay"
                        (completeMethod)="billingToTypeAhead($event)"
                        (onSelect)="selectBillingTo($event)"
                        [dropdown]="true"
                        dropdownIcon="pi pi-search"
                        class="w-full"
                        [ngClass]="{
                          'ng-invalid ng-dirty': orderDetailsFormSubmitted && orderDetailsForm.controls['billingTo'].invalid,
                        }"
                      />
                    }
                    <small id="billingTo" *ngIf="billingSameAsClient.value ? orderDetailsForm.value?.customer?.code : orderDetailsForm.value?.billingTo?.code">{{
                      billingSameAsClient.value ? orderDetailsForm.value?.customer?.code : orderDetailsForm.value?.billingTo?.code
                    }}</small>
                  </div>

                  <!-- Address -->
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Billing_Address' | translateWF: 'Billing Address' }}</label>
                    <p-select
                      fluid
                      appendTo="body"
                      formControlName="billingAddressCode"
                      [options]="getBillingAddresses()"
                      optionLabel="fieldToDisplay"
                      optionValue="code"
                      class="w-full"
                    >
                      <ng-template let-address pTemplate="item">
                        <div class="panel__option" [title]="address.fieldToDisplay">
                          {{ address.fieldToDisplay }}
                        </div>
                      </ng-template>
                    </p-select>
                  </div>
                  <!-- Payment Terms -->
                  <div class="form-box">
                    <label class="required">{{ 'Work_Order_Details_Payment_Terms' | translateWF: 'Payment Terms' }}</label>
                    <csl-dropdown-master-data
                      class="w-full"
                      formControlName="paymentTermsClientCode"
                      categoryCode="PaymentTermsClient"
                      [allowCreate]="false"
                      [ngClass]="{
                        'ng-invalid ng-dirty': orderDetailsFormSubmitted && orderDetailsForm.controls['paymentTermsClientCode'].invalid,
                      }"
                    />
                  </div>
                  <h4 class="my-[1rem]">{{ 'Work_Order_Details_Shipping' | translateWF: 'Shipping' }}</h4>
                  <div class="form-box-row row-start-center">
                    <p-checkbox inputId="shippingSameAsBilling" [binary]="true" [formControl]="shippingSameAsBilling"></p-checkbox>
                    <label for="shippingSameAsBilling" class="ml-2">Same as Billing</label>
                  </div>

                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Shipment_Type' | translateWF: 'Shipment Type' }}</label>
                    <p-select
                      appendTo="body"
                      formControlName="shipmentType"
                      [options]="setOptionsForPrimeNg(shipmentTypeEnums)"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && orderDetailsForm.controls['shipmentType'].invalid }"
                    />
                  </div>

                  @if (!shippingSameAsBilling.value) {
                    <div class="form-box">
                      <label>{{ 'Work_Order_Details_Ship_To' | translateWF: 'Ship To' }}</label>
                      <p-autocomplete
                        appendTo="body"
                        fluid
                        id="shippingTo"
                        formControlName="shippingTo"
                        [suggestions]="shippingToOptions"
                        field="fieldToDisplay"
                        (completeMethod)="shippingToTypeAhead($event)"
                        [dropdown]="true"
                        dropdownIcon="pi pi-search"
                        class="w-full"
                        [ngClass]="{
                          'ng-invalid ng-dirty': orderDetailsFormSubmitted && orderDetailsForm.controls['shippingTo'].invalid,
                        }"
                      >
                      </p-autocomplete>

                      <small id="billingTo" *ngIf="orderDetailsForm.value?.shippingTo?.code">{{ orderDetailsForm.value.shippingTo.code }}</small>
                    </div>

                    <!-- Address -->
                    <div class="form-box">
                      <label>{{ 'Work_Order_Details_Billing_Address' | translateWF: 'Shipping Address' }}</label>
                      <p-select
                        fluid
                        appendTo="body"
                        formControlName="shippingAddressCode"
                        [options]="filterAddresses(orderDetailsForm.value.shippingTo?.addresses, 1) || []"
                        optionLabel="fieldToDisplay"
                        optionValue="code"
                        class="w-full"
                      >
                        <ng-template let-address pTemplate="item">
                          <div class="panel__option" [title]="address.fieldToDisplay">
                            {{ address.fieldToDisplay }}
                          </div>
                        </ng-template>
                      </p-select>
                    </div>
                  }
                </form>
              </p-card>
            </p-tabpanel>
            <!-- Tab Client Product Orders -->
            <p-tabpanel value="1">
              <p-card data-variant="flat">
                <div class="col">
                  <!-- Product Order Number -->
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Product_Order_Number' | translateWF: 'Product Order Number' }}</label>
                    <input [formControl]="productOrderNumber" type="text" pInputText class="w-full" [ngClass]="{ 'ng-invalid ng-dirty': customerProductOrders.length === 0 }" />
                  </div>
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Client_Reference' | translateWF: 'Client Reference' }}</label>
                    <input [formControl]="clientOrderReference" type="text" pInputText class="w-full" />
                  </div>

                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Date_Received' | translateWF: 'Date Received' }}</label>

                    <p-datepicker
                      fluid
                      [formControl]="productOrderNumberDateReceived"
                      [iconDisplay]="'input'"
                      [showIcon]="true"
                      class="w-full"
                      [ngClass]="{ 'ng-invalid ng-dirty': customerProductOrders.length === 0 }"
                    />
                  </div>
                  <div class="row-end-stretch mb-[2rem]">
                    <p-button
                      label="Add"
                      icon="pi pi-plus"
                      iconPos="left"
                      [disabled]="productOrderNumber.value === '' || productOrderNumberDateReceived.value === null || !canEdit()"
                      (click)="addCustomerProductOrder()"
                    />
                  </div>
                  <!-- Product Orders -->
                  <h4 class="mb-[1rem]">{{ 'Work_Order_Details_Product_Orders' | translateWF: 'Product Orders' }}</h4>
                  @if (this.customerProductOrders.length > 0) {
                    @for (productOrder of customerProductOrders; track $index) {
                      <div class="order__card">
                        <h3>
                          {{ productOrder.productOrderNumber }} <small style="color: #2d514e">{{ productOrder.clientOrderReference }}</small>
                        </h3>
                        <div>
                          {{ productOrder.dateReceived | date: 'MM/dd/yyyy' }}
                          @if (canEdit()) {
                            <p-button severity="secondary" icon="pi pi-trash" (click)="deleteCustomerProductOrder($index)" />
                          }
                        </div>
                      </div>
                    }
                  } @else {
                    <p-message severity="secondary">{{
                      'Work_Order_Details_No_Product_Order_Added'
                        | translateWF
                          : 'No Product
                    Order Number added'
                    }}</p-message>
                  }
                </div>
              </p-card>
            </p-tabpanel>
            <!-- Tab Info -->
            <p-tabpanel value="2">
              <p-card data-variant="flat">
                <div class="col">
                  <div class="form-box">
                    <label>Yarn Latest Reception Date</label>
                    <p-datepicker [formControl]="yarnLatestReceptionDate" [iconDisplay]="'input'" [showIcon]="true" class="w-full" />
                  </div>
                  <div class="form-box">
                    <label>Knitting Latest Start Date</label>
                    <p-datepicker [formControl]="knittingLatestStartDate" [iconDisplay]="'input'" [showIcon]="true" class="w-full" />
                  </div>
                  <div class="form-box">
                    <label>Knitting Estimated End Date</label>
                    <p-datepicker [formControl]="knittingEstimatedEndDate" [iconDisplay]="'input'" [showIcon]="true" class="w-full" />
                  </div>
                  <div class="form-box">
                    <label>Dyeing Latest Start Date</label>
                    <p-datepicker [formControl]="dyeingLatestStartDate" [iconDisplay]="'input'" [showIcon]="true" class="w-full" />
                  </div>
                  <div class="form-box">
                    <label>Dyeing Estimated End Date</label>
                    <p-datepicker [formControl]="dyeingEstimatedEndDate" [iconDisplay]="'input'" [showIcon]="true" class="w-full" />
                  </div>
                  <div class="form-box">
                    <label>Finishing Estimated Start Date</label>
                    <p-datepicker [formControl]="finishingLatestStartDate" [iconDisplay]="'input'" [showIcon]="true" class="w-full" />
                  </div>
                  <div class="form-box">
                    <label>Finishing Estimated End Date</label>
                    <p-datepicker [formControl]="finishingEstimatedEndDate" [iconDisplay]="'input'" [showIcon]="true" class="w-full" />
                  </div>
                  <div class="form-box">
                    <label>Promised Shipment Date</label>
                    <p-datepicker [formControl]="promisedShipmentDate" [iconDisplay]="'input'" [showIcon]="true" class="w-full" />
                  </div>
                  <form [formGroup]="orderAuditTrailForm">
                    <div class="col">
                      <!-- Created By -->
                      <div class="form-box">
                        <label>{{ 'Work_Order_Details_Created_By' | translateWF: 'Created By' }}</label>
                        <input formControlName="createdBy" type="text" pInputText value="Alberto Subero" class="w-full" />
                      </div>
                      <!-- Created Date -->
                      <div class="form-box">
                        <label>{{ 'Work_Order_Details_Created_Date' | translateWF: 'Created Date' }}</label>
                        <p-datepicker fluid formControlName="createdDate" [iconDisplay]="'input'" [showIcon]="true" class="w-full" />
                      </div>
                      <!-- Modified By -->
                      <div class="form-box">
                        <label>{{ 'Work_Order_Details_Modified_By' | translateWF: 'Modified By' }}</label>
                        <input formControlName="modifiedBy" type="text" pInputText value="Alberto Subero" class="w-full" />
                      </div>
                      <!-- Modified Date -->
                      <div class="form-box">
                        <label>{{ 'Work_Order_Details_Modified_Date' | translateWF: 'Modified Date' }}</label>
                        <p-datepicker fluid formControlName="modifiedDate" [iconDisplay]="'input'" [showIcon]="true" class="w-full" />
                      </div>
                    </div>
                  </form>
                </div>
              </p-card>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </div>
    </div>
  </div>
</main>
<p-toast position="top-center" />
